import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetGroupsAction } from '../../actions/groups/get-groups-action';
import { DeleteGroupAction } from '../../actions/groups/delete-group-action';
import { DeleteGroupErrorAction } from '../../actions/groups/delete-group-error-action';

@Injectable()
export class DeleteGroupEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public DeleteGroup = createEffect(() => this.actions
    .pipe(
      ofType(DeleteGroupAction.type),
      mergeMap(action => {
        const deleteGroupAction = <DeleteGroupAction>action;
        return this.api.deleteGroup(deleteGroupAction.group.id).then(() => {
          return new GetGroupsAction(deleteGroupAction.bijbEvent);
        }, error => {
          return new DeleteGroupErrorAction(error);
        });
      })
    ));
}
